// extracted by mini-css-extract-plugin
module.exports = {"people":"styles_people_2hnkYV1s3lZi2vDL4idYsc","icon":"styles_icon_CqvwZGBEjmcz9cX0Gzk6v","value":"styles_value_1N3bhh0ecMLQChRN-voLqG"};